export const GET_ELEMENTS = "GET_ELEMENTS";
export const REFRESH_ELEMENTS = "REFRESH_ELEMENTS";
export const RESET_ELEMENTS = "RESET_ELEMENTS";
export const SET_ELEMENTS_REQUEST_STATUS = "SET_ELEMENTS_REQUEST_STATUS";
export const DELETE_ELEMENTS = "DELETE_ELEMENTS";
